import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRequireSession } from '../hooks/useRouteGuards';
import { useAppStore } from '../store/useAppStore';
import { Button } from '../components/ui/Button';
import { trackEvent } from '../utils/posthogClient';

const CONFIRMATION_TEXT =
  'Ich bewerte ein konkretes Angebot und antworte nach meiner aktuellen Situation.';

export function PreparationPage() {
  const ready = useRequireSession();
  const goToStep = useAppStore((state) => state.goToStep);
  const stepEnabled = useAppStore((state) => state.settings.featureFlags.preparationStep.enabled);
  const showConfirmationCheckbox = useAppStore(
    (state) => state.settings.featureFlags.preparationStep.showConfirmationCheckbox,
  );
  const analyticsEnabled = useAppStore((state) => state.settings.featureFlags.analytics.enabled);
  const navigate = useNavigate();
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    if (!ready || stepEnabled) return;
    goToStep('context');
    void navigate('/kontext/angebot', { replace: true });
  }, [ready, stepEnabled, goToStep, navigate]);

  if (!ready || !stepEnabled) return null;

  const canContinue = !showConfirmationCheckbox || confirmed;

  function handleContinue(): void {
    if (analyticsEnabled) trackEvent('preparation_completed');
    goToStep('context');
    void navigate('/kontext/angebot');
  }

  return (
    <div className="page-container stack">
      <h1>Bevor es losgeht</h1>

      <div className="two-col-grid">
        <section className="card stack">
          <h2>Bewerte ein konkretes Angebot</h2>
          <p>
            Beantworte den Test für ein konkretes digitales Angebot – nicht für eine allgemeine
            Geschäftsidee.
          </p>
        </section>

        <section className="card stack">
          <h2>Dein aktueller Stand zählt</h2>
          <p>
            Antworte nach deinen aktuellen Voraussetzungen, nicht nach einem gewünschten zukünftigen
            Zustand.
          </p>
        </section>

        <section className="card stack">
          <h2>Die Branche allein reicht nicht</h2>
          <p>
            Zwei Anbieter mit ähnlichem Thema können wegen Zielgruppe, Preis, Sichtbarkeit, Zeit und
            Verkaufsweg zu unterschiedlichen Ergebnissen kommen.
          </p>
        </section>

        <section className="card stack">
          <h2>Keine Erfolgsgarantie</h2>
          <ul>
            <li>Ein hoher Score ist keine Umsatzgarantie.</li>
            <li>Ein niedriger Score ist keine Bewertung deiner Person.</li>
            <li>Ein niedriger Score kann bedeuten, dass ein anderer Kanal besser passt.</li>
          </ul>
        </section>
      </div>

      {showConfirmationCheckbox && (
        <section className="card">
          <label className="checkbox-row">
            <input
              type="checkbox"
              checked={confirmed}
              onChange={(event) => setConfirmed(event.target.checked)}
            />
            <span>{CONFIRMATION_TEXT}</span>
          </label>
        </section>
      )}

      <Button onClick={handleContinue} disabled={!canContinue}>
        Weiter zu den Kontextfragen
      </Button>
    </div>
  );
}
